import { useSettingsStore } from '@/store/settings/settings'

const getters = {
  getCollectionsForCampaignForm(state) {
    return {
      browsers: state.browsers,
      carriers: state.carriers,
      categories: state.categories,
      categoryGroups: state.categoryGroups,
      countries: state.countries,
      deviceModels: state.deviceModels,
      ip2LocationTypes: state.ip2LocationTypes,
      languages: state.languages,
      operatingSystems: state.operatingSystems,
      trafficTypes: state.trafficTypes,
      deviceVendors: state.deviceVendors,
      interests: state.interests,
      conversionTypes: state.conversionTypes,
      referrerTypes: state.referrerTypes,

      carriersAreLoading: state.carriersAreLoading,
      categoriesAreLoading: state.categoriesAreLoading,
      categoryGroupsAreLoading: state.categoryGroupsAreLoading,
      countriesAreLoading: state.countriesAreLoading,
      deviceModelsAreLoading: state.deviceModelsAreLoading,
      ip2LocationTypesAreLoading: state.ip2LocationTypesAreLoading,
      languagesAreLoading: state.languagesAreLoading,
      operatingSystemsAreLoading: state.operatingSystemsAreLoading,
      trafficTypesAreLoading: state.trafficTypesAreLoading,
      deviceVendorsAreLoading: state.deviceVendorsAreLoading,
      interestsAreLoading: state.interestsAreLoading,
      conversionTypesAreLoading: state.conversionTypesAreLoading,
      trafficPlatforms: state.trafficPlatforms,
      trafficPlatformsAreLoading: state.trafficPlatformsAreLoading,
      referrerTypesAreLoading: state.referrerTypesAreLoading
    }
  },
  defaultInPageSkin(state) {
    const skins = state.inPageSkinGroups.reduce((acc, group) => {
      acc.push(...group.inPageSkins)
      return acc
    }, [])
    const { defaultInPageSkinId } = useSettingsStore()
    return skins.find((skin) => skin.id === +defaultInPageSkinId) ?? null
  }
}

export default getters
